export default __webpack_public_path__ + "static/media/ubicacionNew.586465b4.svg";